import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-910ffe86")

_pushScopeId("data-v-910ffe86")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = { class: "scoreboxbig" }
const _hoisted_4 = { class: "score" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "fen" }, "分", -1)
const _hoisted_6 = { class: "chartname" }
const _hoisted_7 = { class: "tb" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "itme" }, [
  /*#__PURE__*/_createVNode("div", null, "检测指标"),
  /*#__PURE__*/_createVNode("div", null, "检测结果"),
  /*#__PURE__*/_createVNode("div", null, "提示"),
  /*#__PURE__*/_createVNode("div", null, "参考范围")
], -1)
const _hoisted_9 = { class: "val" }
const _hoisted_10 = { class: "val" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "val" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "val" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "val" }
const _hoisted_19 = { class: "codetxt" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "name" }, "评估结果", -1)
const _hoisted_21 = { class: "val" }
const _hoisted_22 = { class: "codetxt" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "name" }, "常见症状", -1)
const _hoisted_24 = { class: "val" }
const _hoisted_25 = { class: "codetxt" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "name" }, "好发疾病", -1)
const _hoisted_27 = { class: "val" }
const _hoisted_28 = { class: "codetxt" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "name" }, "调理建议", -1)
const _hoisted_30 = { class: "val" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ScoreNum = _resolveComponent("ScoreNum")

  return (_ctx.data && _ctx.data.detailInfo)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.detailInfo, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "card version7",
            key: item.detailName
          }, [
            _createVNode("div", _hoisted_2, _toDisplayString(item.detailName), 1),
            _withDirectives(_createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_ScoreNum, {
                  score: parseInt(item.score),
                  addZero: true
                }, null, 8, ["score"])
              ]),
              _hoisted_5
            ], 512), [
              [_vShow, item.score]
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.imgList, (img) => {
              return (_openBlock(), _createBlock("div", {
                key: img.name
              }, [
                _createVNode("img", {
                  class: "chartimg",
                  src: img.url,
                  alt: img.name
                }, null, 8, ["src", "alt"]),
                _createVNode("div", _hoisted_6, _toDisplayString(img.name), 1)
              ]))
            }), 128)),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.codeInfoList, (code) => {
                return (_openBlock(), _createBlock("div", {
                  class: "itme",
                  key: code.name
                }, [
                  _createVNode("div", null, _toDisplayString(code.name), 1),
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_9, _toDisplayString(code.score), 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_10, [
                      (code.description == -1)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _hoisted_11
                          ], 64))
                        : _createCommentVNode("", true),
                      (code.description == 1)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _hoisted_12
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (code.minInterval && code.maxInterval)
                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                        _createVNode("span", _hoisted_14, _toDisplayString(code.minInterval + '~' + code.maxInterval), 1)
                      ]))
                    : (code.minInterval)
                      ? (_openBlock(), _createBlock("div", _hoisted_15, [
                          _createVNode("span", _hoisted_16, "≥" + _toDisplayString(code.minInterval), 1)
                        ]))
                      : (code.maxInterval)
                        ? (_openBlock(), _createBlock("div", _hoisted_17, [
                            _createVNode("span", _hoisted_18, "≤" + _toDisplayString(code.maxInterval), 1)
                          ]))
                        : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("span", _hoisted_21, _toDisplayString(item.evaluationResult), 1)
            ]),
            _createVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode("span", _hoisted_24, _toDisplayString(item.symptom || '无'), 1)
            ]),
            _createVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode("span", _hoisted_27, _toDisplayString(item.warning || '无'), 1)
            ]),
            _createVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode("span", _hoisted_30, _toDisplayString(item.suggestion || '无'), 1)
            ])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
})